import * as query from './reducers/query';
import * as settleManually from './reducers/settle-manually';
import * as settle from './reducers/settle';
import * as calculatePayout from './reducers/calculate-payout';
import * as parkBet from './reducers/park-bet';
import * as cancelBet from './reducers/cancel-bet';
import * as commentBet from './reducers/comment-bet';
import * as update from './reducers/update';
import * as betUnsettlement from './reducers/unsettlement';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    BETS_QUERY_REQUEST: query.request,
    BETS_QUERY_ERROR: query.error,
    BETS_QUERY_FINISH: query.finish,
    BETS_QUERY_CLEAR: query.clear,

    BETS_SETTLE_MANUALLY_REQUEST: settleManually.request,
    BETS_SETTLE_MANUALLY_ERROR: settleManually.error,
    BETS_SETTLE_MANUALLY_FINISH: settleManually.finish,

    BETS_SETTLE_REQUEST: settle.request,
    BETS_SETTLE_ERROR: settle.error,
    BETS_SETTLE_FINISH: settle.finish,

    BETS_CALCULATE_PAYOUT_REQUEST: calculatePayout.request,
    BETS_CALCULATE_PAYOUT_ERROR: calculatePayout.error,
    BETS_CALCULATE_PAYOUT_FINISH: calculatePayout.finish,

    BETS_COMMENT_BET_REQUEST: commentBet.request,
    BETS_COMMENT_BET_ERROR: commentBet.error,
    BETS_COMMENT_BET_FINISH: commentBet.finish,

    BETS_PARK_BET_REQUEST: parkBet.request,
    BETS_PARK_BET_ERROR: parkBet.error,
    BETS_PARK_BET_FINISH: parkBet.finish,

    BETS_CANCEL_BET_REQUEST: cancelBet.request,
    BETS_CANCEL_BET_ERROR: cancelBet.error,
    BETS_CANCEL_BET_FINISH: cancelBet.finish,

    BETS_UNSETTLEMENT_REQUEST: betUnsettlement.request,
    BETS_UNSETTLEMENT_ERROR: betUnsettlement.error,
    BETS_UNSETTLEMENT_FINISH: betUnsettlement.finish,

    BET_DATA: update.update,
    BETS_DATA: update.bulk,
});
